import {loginContainer} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {MINI_SCREENS_VIEWS_DOCUMENT} from 'src/js/model/mini_screens_config';

import AutoLayoutContainer from './AutoLayoutContainer';
import styles from './DynamicAutoLayoutBox.less';
import ScreenSwitcher from './ScreenSwitcher';

class DynamicAutoLayoutBox extends React.PureComponent {
  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      handleSelectedScreenIdChange,
      helpText,
      miniScreensConfig,
      screenId,
      screenStyles,
      showBoxHeader,
      titleText,
    } = this.props;
    return (
      <div
        className={styles.dlDynamicAutoLayoutBox}
        data-name={'DynamicAutoLayoutBoxWrapper'}
      >
        {!isEmpty(screenId) ? (
          <div className={styles.dlDynamicAutoLayoutBoxWithSelector}>
            {miniScreensConfig &&
            miniScreensConfig.isLoaded() &&
            miniScreensConfig.getScreensByView(MINI_SCREENS_VIEWS_DOCUMENT)
              .length > 1 ? (
              <div className={styles.dlDynamicAutoLayoutBoxScreenSwitcher}>
                <ScreenSwitcher
                  screenIds={miniScreensConfig.getScreensByView(
                    MINI_SCREENS_VIEWS_DOCUMENT
                  )}
                  selectedScreenId={screenId}
                  onChange={handleSelectedScreenIdChange}
                />
              </div>
            ) : null}
            <AutoLayoutContainer
              autoLayoutStateId={autoLayoutStateId}
              config={config}
              configStateId={configStateId}
              contextParams={contextParams}
              screenId={screenId}
              screenStyles={screenStyles}
              showBoxHeader={showBoxHeader}
              titleText={titleText}
              helpText={helpText}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

DynamicAutoLayoutBox.displayName = 'DynamicAutoLayoutBox';

DynamicAutoLayoutBox.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSelectedScreenIdChange: PropTypes.func.isRequired,
  helpText: PropTypes.string,
  miniScreensConfig: PropTypes.objectOf(PropTypes.any).isRequired,
  screenId: PropTypes.string,
  screenStyles: PropTypes.objectOf(PropTypes.any),
  showBoxHeader: PropTypes.bool,
  titleText: PropTypes.string,
};

DynamicAutoLayoutBox.defaultProps = {
  helpText: '',
  screenId: '',
  screenStyles: undefined,
  showBoxHeader: false,
  titleText: '',
};

export default DynamicAutoLayoutBox;
